// extracted by mini-css-extract-plugin
export default {"button":"MoveButton_button__dzt8L","emoji":"MoveButton_emoji__-AZBb","container":"MoveButton_container__FosKm","wiggle":"MoveButton_wiggle__F7KLQ"};